import React from "react";

export default function GoogleCalendar({ className }) {
  return (
    <>
      <svg
        width="32"
        height="33"
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M29.5879 0H24.3857V7.57893H31.9977V2.13706C31.9998 2.13706 31.6216 0.206679 29.5879 0Z"
          fill="#1967D2"
        />
        <path
          d="M24.3877 32.1375V32.1561V32.1727L31.9997 24.5938H31.9315L24.3877 32.1375Z"
          fill="#1967D2"
        />
        <path
          d="M31.9992 24.591V24.5234L31.9316 24.591H31.9992Z"
          fill="#FBBC05"
        />
        <path
          d="M31.9997 7.57031H24.3877V24.518H31.9997V7.57031Z"
          fill="#FBBC05"
        />
        <path
          d="M31.9315 24.5938H24.3877V32.1375L31.9315 24.5938Z"
          fill="#EA4335"
        />
        <path
          d="M24.3877 24.5916H31.9315L31.9997 24.5234H24.3877V24.5916Z"
          fill="#EA4335"
        />
        <path
          d="M24.3701 32.1583H24.3878V32.1406L24.3701 32.1583Z"
          fill="#34A853"
        />
        <path
          d="M7.44043 24.5234V32.154H24.3695L24.3881 24.5234H7.44043Z"
          fill="#34A853"
        />
        <path
          d="M24.3887 24.5916V24.5234L24.3701 32.154L24.3887 32.1354V24.5916Z"
          fill="#34A853"
        />
        <path
          d="M0 24.5234V29.8289C0.0682042 31.5505 1.92005 32.154 1.92005 32.154H7.44046V24.5234H0Z"
          fill="#188038"
        />
        <path
          d="M7.44046 7.57893H24.3882V0H2.135C2.135 0 0.136408 0.206679 0 2.34168V24.5266H7.44046V7.57893Z"
          fill="#4285F4"
        />
        <path
          d="M12.9854 21.1023C12.5977 21.1023 12.2238 21.0515 11.8638 20.95C11.513 20.8484 11.1899 20.6961 10.8944 20.493C10.599 20.2807 10.3359 20.0176 10.1051 19.7037C9.88357 19.3898 9.71279 19.0252 9.59277 18.6098L11.296 17.9312C11.416 18.3928 11.6191 18.7436 11.9053 18.9837C12.1915 19.2144 12.5515 19.3298 12.9854 19.3298C13.1793 19.3298 13.3639 19.3021 13.5393 19.2468C13.7147 19.1821 13.867 19.0944 13.9963 18.9837C14.1255 18.8729 14.2271 18.7436 14.3009 18.5959C14.384 18.439 14.4256 18.2636 14.4256 18.0697C14.4256 17.6635 14.2732 17.345 13.9686 17.1142C13.6732 16.8834 13.2624 16.768 12.7362 16.768H11.9192V15.1202H12.6669C12.8516 15.1202 13.0316 15.0971 13.207 15.051C13.3824 15.0048 13.5347 14.9356 13.6639 14.8432C13.8024 14.7417 13.9086 14.6171 13.9824 14.4694C14.0655 14.3124 14.1071 14.1324 14.1071 13.9293C14.1071 13.6154 13.9963 13.3616 13.7747 13.1677C13.5532 12.9646 13.2531 12.863 12.8746 12.863C12.4684 12.863 12.1546 12.9738 11.933 13.1954C11.7207 13.4077 11.573 13.6477 11.4899 13.9155L9.82818 13.2369C9.91127 13.0061 10.0359 12.7707 10.2021 12.5307C10.3682 12.2815 10.5759 12.0599 10.8252 11.866C11.0837 11.6629 11.3837 11.5014 11.7253 11.3814C12.0669 11.2521 12.4592 11.1875 12.9023 11.1875C13.3547 11.1875 13.7655 11.2521 14.1348 11.3814C14.5133 11.5106 14.8364 11.6906 15.1041 11.9214C15.3718 12.143 15.5795 12.4107 15.7272 12.7246C15.8749 13.0292 15.9488 13.3616 15.9488 13.7216C15.9488 13.9985 15.9119 14.2478 15.838 14.4694C15.7734 14.6909 15.6857 14.8894 15.5749 15.0648C15.4641 15.2402 15.3349 15.3925 15.1872 15.5218C15.0487 15.6418 14.9056 15.7387 14.7579 15.8126V15.9234C15.201 16.0988 15.5657 16.3803 15.8519 16.768C16.1473 17.1558 16.295 17.6451 16.295 18.2359C16.295 18.6513 16.2165 19.0344 16.0596 19.3852C15.9026 19.7268 15.6764 20.0268 15.381 20.2853C15.0949 20.5438 14.7487 20.7423 14.3425 20.8808C13.9363 21.0285 13.4839 21.1023 12.9854 21.1023Z"
          fill="#4285F4"
        />
        <path
          d="M19.6018 20.8808V13.5416L17.9263 14.2478L17.2616 12.7107L20.0449 11.4091H21.4158V20.8808H19.6018Z"
          fill="#4285F4"
        />
      </svg>
    </>
  );
}
